import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import AnalyticsDashboard from '../components/AnalyticsDashboard';
import SEOHead from '../components/SEOHead';
import BreadcrumbSchema from '../components/BreadcrumbSchema';
import { useAuth } from '../contexts/AuthContext';

const Analytics: React.FC = () => {
  const { currentUser } = useAuth();
  
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEOHead 
        title="Analytics - ClipThis"
        description="Track your video performance and clip engagement with detailed analytics."
      />
      <BreadcrumbSchema items={[
        { name: 'Analytics', path: '/analytics' }
      ]} />
      <div className="relative overflow-x-hidden" style={{ minHeight: 'calc(100vh - 64px)' }}>
        {/* Subtle animated background */}
        <div className="absolute inset-0 dot-pattern-animated opacity-60 pointer-events-none" />
        
        <div className="relative z-10 px-6 sm:px-8 pt-4 animate-fade-up">
          {/* Back Button */}
          <Link 
            to={currentUser ? "/dashboard" : "/"}
            className="inline-flex items-center space-x-2 text-primary-600 hover:text-primary-700 transition-colors mb-8"
          >
            <ArrowLeft size={20} />
            <span>Back to {currentUser ? "Dashboard" : "Home"}</span>
          </Link>
          
          <AnalyticsDashboard />
        </div>
      </div>
    </>
  );
};

export default Analytics; 